__turbopack_context__.v({
  "mobileViewWrapper": "V1CheckoutAndIdentity-module__Rx3sla__mobileViewWrapper",
});
